<template>
  <div>
    <JadeDrawer
      :open.sync="selfOpen"
      :title="$t('title')"
      @toggle="handleToggle"
    >
      <JadeBox>
        <DataInfosContainer :data="computedInfos" />

        <DataAntifraudContainer
          v-if="computedAntifraud"
          :data="computedAntifraud"
        />

        <DataAcquirerContainer
          v-if="computedAcquirer"
          :data="computedAcquirer"
          @handleCopied="handleToast"
        />
        <DataOthersContainer
          v-if="computedOthers.hasOthers"
          :data="computedOthers"
        />
        <JadeBox has-padding>
          <slot name="log"></slot>
        </JadeBox>
      </JadeBox>
    </JadeDrawer>
    <JadeToastHub ref="toast" />
  </div>
</template>

<script>
import { JadeDrawer, JadeBox, JadeToastHub } from '@jade'

import TransactionDetailsManager from './transaction-details.manager'

export default {
  name: 'TransactionDetails',

  components: {
    JadeDrawer,
    JadeBox,
    JadeToastHub,

    DataInfosContainer: () => import('./DataInfosContainer.vue'),
    DataAntifraudContainer: () => import('./DataAntifraudContainer.vue'),
    DataAcquirerContainer: () => import('./DataAcquirerContainer.vue'),
    DataOthersContainer: () => import('./DataOthersContainer.vue')
  },

  props: {
    open: Boolean,
    data: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      selfOpen: false
    }
  },

  computed: {
    computedInfos () {
      return new TransactionDetailsManager(this.data).adapterData()
    },
    computedAntifraud () {
      return new TransactionDetailsManager(this.data).adapterDataAntiFraud()
    },
    computedAcquirer () {
      return new TransactionDetailsManager(this.data).adapterDataAcquirer()
    },
    computedOthers () {
      return new TransactionDetailsManager(this.data).adapterOthers()
    }
  },

  created () {
    this.selfOpen = this.open
  },

  methods: {
    handleToggle () {
      this.selfOpen = !this.selfOpen
      this.$emit('update:open', this.selfOpen)
    },
    handleToast (value) {
      this.$refs.toast.addToast({
        text: `${this.$t('general.copied')}: ${value}`,
        icon: 'action-copy'
      })
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "title": "Detalhe"
    },
    "en-US": {
      "title": "Detail"
    }
  }
</i18n>
